import React from 'react'

type Props = React.PropsWithChildren<{
  className?: string
}>

function TransitPreviewDocumentsSection({
  className,
  children,
}: Props) {
  return (
    <div className={`p-2 ${className ?? ''}`}>
      {children}
    </div>
  )
}

TransitPreviewDocumentsSection.defaultProps = {
  className: undefined,
}

export default TransitPreviewDocumentsSection
